import { createSlice } from '@reduxjs/toolkit';
import { act } from 'react';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isLoggedIn: false,
        user: null,
    },
    reducers: {
        setLoginState: (state, action) => {
            state.isLoggedIn = action.payload.isLoggedIn;
            state.user = action.payload.user;
        },
        logout: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
    },
});

export const { setLoginState, logout } = authSlice.actions;

export default authSlice.reducer;

//// after receiving res.data from /status or /login
//dispatch(setloginstate({
//    isloggedin: res.data.isauthenticated,
//    user: {
//        username: res.data.username,
//        memberid: res.data.memberid,
//        fullname: res.data.fullname, // if available
//        roles: res.data.roles,
//    },
//    claims: {
//        memberid: res.data.memberid,
//        fullname: res.data.fullname, // if available
//        roles: res.data.roles,
//    }
//}));